<template>
	<div class="h-100">
		<sitemap v-if="isSitemap" />
		<sf-iframe
			v-else-if="screenData.url"
			:url="screenData.url"
			:screenParam="{ scrId: screenData.scrId }"
			:iframeParam="userInfo"
			@load="load"
		/>
	</div>
</template>

<script>
//MenuLayout의 서브 라우팅 화면
//MenuLayout가 tab 형식이 아닐 경우 서브 라우팅으로 처리
import { rootComputed, rootMethods } from '@/store/common/helpers';
import Sitemap from '@/views/Pages/Sitemap/Sitemap';

export default {
	components: { Sitemap },

	data() {
		return {
			screenData: {}, //화면 정보
			isSitemap: true //사이트맵 표시 여부
		};
	},

	//mounted 될 때
	mounted() {
		this.setScreen(); // 화면정보 셋팅 함수 호출
	},

	computed: {
		...rootComputed,

		// 화면 iframe에게 전달할 쿼리 스트링 정보: 사용자 정보
		userInfo() {
			return {
				topSkin: this.topSkin, //색상 테마
				font: this.font, //폰트 테마
				plantCd: this.user.plantCd, //공장 코드
				langCd: this.langCd //언어
			};
		}
	},

	watch: {
		//화면 정보 변경 감지
		$route() {
			this.setScreen();
		}
	},

	methods: {
		...rootMethods,

		//ScreenLayout에 보여줄 정보 Set하는 함수
		setScreen() {
			//this.$route 에서 메뉴 name과 scrId 정보 추출
			const name = this.$route.name.split('Screen')[0];
			const scrId = this.$route.path.split('/')[this.$route.path.split('/').length - 1];

			//화면 정보가 sitemap일 경우
			if (scrId === 'sitemap') {
				this.isSitemap = true; //sitemap Display
			}
			//sitemap 아닐 경우
			else {
				this.screenData = this.getMenu_({ name }).menuItemMap.get(this.$route.params.scrId); //메뉴에서 화면 정보 조회해서 screenData에 Set
				this.isSitemap = false; //sitemap hide
			}
		},

		//iframe load 되었을 때
		load(iframe) {
			//Direct 이동 화면이라면 자식 iframe에게 post로 parameter 전달
			if (this.screenData.direct) {
				iframe.contentWindow.postMessage({ message: 'sendUser', ...this.getUser_ }, '*');
			}
		}
	}
};
</script>

<style></style>
